import { render, staticRenderFns } from "./RunnitTemplatesOnboardingDialog.vue?vue&type=template&id=327f73c2&scoped=true"
import script from "./RunnitTemplatesOnboardingDialog.vue?vue&type=script&lang=ts"
export * from "./RunnitTemplatesOnboardingDialog.vue?vue&type=script&lang=ts"
import style0 from "./RunnitTemplatesOnboardingDialog.vue?vue&type=style&index=0&id=327f73c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f73c2",
  null
  
)

export default component.exports